import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './AccessDenied.css';

interface AccessDeniedProps {
  message?: string;
  contact?: string;
}

export const AccessDenied: React.FC<AccessDeniedProps> = ({ 
  message = 'You do not have permission to access the WAD Admin Tools. Please contact Van.Vuong@bswhealth.org to request access.',
  contact = 'Van.Vuong@bswhealth.org'
}) => {
  const { user, logout } = useAuth();

  const handleContactClick = () => {
    const subject = encodeURIComponent('Request Access to WAD Admin Tools');
    const body = encodeURIComponent(
      `Hello,\n\n` +
      `I would like to request access to the WAD Admin Tools application.\n\n` +
      `My details:\n` +
      `Name: ${user?.name || 'N/A'}\n` +
      `Email: ${user?.email || 'N/A'}\n\n` +
      `Please let me know what information you need to process this request.\n\n` +
      `Thank you!`
    );
    window.location.href = `mailto:${contact}?subject=${subject}&body=${body}`;
  };

  return (
    <div className="access-denied-container">
      <div className="access-denied-content">
        <div className="access-denied-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path 
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" 
              fill="#FF6B6B"
            />
            <path 
              d="M12 7v5M12 14h.01" 
              stroke="#FFF" 
              strokeWidth="2" 
              strokeLinecap="round"
            />
          </svg>
        </div>
        
        <h1 className="access-denied-title">Access Denied</h1>
        
        <div className="access-denied-user-info">
          <p><strong>Logged in as:</strong></p>
          <p className="user-name">{user?.name}</p>
          <p className="user-email">{user?.email}</p>
        </div>
        
        <p className="access-denied-message">{message}</p>
        
        <div className="access-denied-actions">
          <button 
            className="btn btn-primary"
            onClick={handleContactClick}
          >
            Request Access
          </button>
          
          <button 
            className="btn btn-secondary"
            onClick={logout}
          >
            Sign Out
          </button>
        </div>
        
        <div className="access-denied-footer">
          <p className="contact-info">
            <strong>Contact:</strong> 
            <a href={`mailto:${contact}`} className="contact-link">
              {contact}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;